export function getIsoTimestringWithMicroseconds() {
  const now = new Date();
  const milliseconds = now.getUTCMilliseconds();
  const microseconds = milliseconds * 1000;
  const isoString = now.toISOString();
  const microsecondsString = String(microseconds).padStart(6, '0');
  const isoWithMicro = isoString.replace(/\.([0-9]{3})Z/, `.${microsecondsString}Z`);
  return isoWithMicro;
}
